'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ServerApp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _reduxConnect = require('redux-connect');

var _reactRouter = require('react-router');

var _AppConfigProvider = require('../../helpers/AppConfigProvider');

var _AppConfigProvider2 = _interopRequireDefault(_AppConfigProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServerApp(_ref) {
  var appConfig = _ref.appConfig,
      store = _ref.store,
      req = _ref.req,
      renderProps = _ref.renderProps;

  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store, key: 'provider' },
    _react2.default.createElement(
      _reactI18next.I18nextProvider,
      { i18n: req.i18n },
      _react2.default.createElement(
        _AppConfigProvider2.default,
        { config: appConfig },
        _react2.default.createElement(
          _reactRouter.RouterContext,
          renderProps,
          _react2.default.createElement(_reduxConnect.ReduxAsyncConnect, null)
        )
      )
    )
  );
}

ServerApp.propTypes = {
  appConfig: _react.PropTypes.any,
  store: _react.PropTypes.any.isRequired,
  req: _react.PropTypes.any.isRequired,
  renderProps: _react.PropTypes.object.isRequired
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/chemist/dist/middleware/rendering/ServerApp.js
// module id = 588
// module chunks = 0